const SvgSupplyChain1 = (props) => (
  <>
    <path
      d="M96 0C42.98 0 0 42.98 0 96s42.98 96 96 96 96-42.98 96-96S149.02 0 96 0Zm0 144c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48Z"
      fill={props.p20}
    />
    <circle cx={96} r={4} fill={props.p30} />
    <circle cx={180} cy={48} r={4} fill={props.p30} />
    <circle cx={180} cy={144} r={4} fill={props.p30} />
    <circle cx={12} cy={48} r={4} fill={props.p30} />
    <circle cx={12} cy={144} r={4} fill={props.p30} />
    <circle cx={96} cy={192} r={4} fill={props.p30} />
  </>
);

export default SvgSupplyChain1;
